/**
 * Daily Report Service
 * Wraps all /api/daily-reports endpoints
 */
import api from './api';

const dailyReportService = {
  /**
   * HR submits a daily report
   * POST /api/daily-reports
   */
  createReport: async (payload) => {
    const response = await api.post('/daily-reports', payload);
    return response.data;
  },

  /**
   * HR gets own paginated reports
   * GET /api/daily-reports/my
   */
  getMyReports: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.page)  query.append('page',  params.page);
    if (params.limit) query.append('limit', params.limit);
    const response = await api.get(`/daily-reports/my?${query.toString()}`);
    return response.data;
  },

  /**
   * Check whether today's report already exists for the logged-in HR
   * GET /api/daily-reports/today
   */
  getTodayReport: async () => {
    const response = await api.get('/daily-reports/today');
    return response.data;
  },

  /**
   * Chairman: get all reports with optional filters
   * GET /api/daily-reports
   */
  getAllReports: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.fromDate) query.append('fromDate', params.fromDate);
    if (params.toDate)   query.append('toDate',   params.toDate);
    if (params.hrId)     query.append('hrId',     params.hrId);
    if (params.status)   query.append('status',   params.status);
    if (params.page)     query.append('page',     params.page);
    if (params.limit)    query.append('limit',    params.limit);
    const response = await api.get(`/daily-reports?${query.toString()}`);
    return response.data;
  },

  /**
   * Get a single report by ID (HR can only see own; Chairman sees all)
   * GET /api/daily-reports/:id
   */
  getReportById: async (id) => {
    const response = await api.get(`/daily-reports/${id}`);
    return response.data;
  },

  /**
   * Chairman adds / updates feedback on a report
   * PUT /api/daily-reports/:id/feedback
   */
  addFeedback: async (id, chairmanFeedback) => {
    const response = await api.put(`/daily-reports/${id}/feedback`, { chairmanFeedback });
    return response.data;
  },

  /**
   * Adds a reply to the conversation
   * POST /api/daily-reports/:id/reply
   */
  addReply: async (id, message) => {
    const response = await api.post(`/daily-reports/${id}/reply`, { message });
    return response.data;
  }
};

export default dailyReportService;
